import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tariff } from '../../models/tariff.model';
import { HttpResponse, HttpParams } from '@angular/common/http';
import { SortItem } from 'src/app/core/models/sort-item.model';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { Subscription } from 'rxjs';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';
import { TariffService } from '../../services/tariff.service';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-tariff',
  templateUrl: './tariff.component.html',
  styleUrls: ['./tariff.component.css']
})
export class TariffComponent implements OnInit {
  refreshSubscription: Subscription;
  tariffs: Tariff[] = [];
  entityName: string = 'tariff';
  sortItems: SortItem[] = [
    {
      title: 'ID',
      code: 'select',
      sortOrder: 'asc',
      width: 100,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Název',
      code: 'title',
      sortOrder: 'asc',
      width: 156,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Počet výtahů',
      code: 'CompanyName',
      sortOrder: 'asc',
      width: 210,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Počet uživatelů',
      code: 'Phone',
      sortOrder: 'asc',
      width: 210,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Akce',
      code: 'action',
      sortOrder: 'asc',
      width: 50,
      disabled: true,
      isEmpty: true,
      class: null
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entityListRefresh: EntityListRefresh,
    private progressBarService: ProgressBarService,
    private tariffService: TariffService,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    const response: HttpResponse<Tariff[]> = this.route.snapshot.data.tariffs;
    this.tariffs = response.body;

    this.refreshSubscription = this.entityListRefresh.refresh$.subscribe((entityName: string) => {
      if (this.entityName === entityName) {
        this.reloadData();
      }
    });
  }

  destroyData() {
    // prevent memory leak when component destroyed
    this.refreshSubscription.unsubscribe();
  }

  createTariff() {
    this.router.navigate([{ outlets: { modal: 'create-tariff' } }]);
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['tariff-detail', id] } }]);
  }

  delete(id: number) {
    if (confirm('Chcete opravdu smazat tarif?')) {
      this.tariffService.delete(id).subscribe(() => {
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Tarif byl smazán'
        });
        this.reloadData();
      });
    } 
  }

  reloadData() {
    this.progressBarService.start();
    this.tariffService.get(new HttpParams().set('orderby', 'Id Asc'))
      .subscribe((response: HttpResponse<Tariff[]>) => {
        this.tariffs = response.body;
        this.progressBarService.end();
      });
  }

}
